// ticket-filter.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TicketStatusWithSubS } from './interfaces/ticket-status-with-sub-s';

export interface TicketFilters {
  /**
   * ID sottostato selezionati (filtro multiplo).
   * - null: non ancora inizializzato → al primo ingresso si applicano i default dipartimento
   * - []: nessun filtro stato (es. dopo reset esplicito) → non riapplicare i default
   * - [ids]: filtro attivo
   */
  substatusIds: number[] | null;
  system: string | null;
  technician: string | null;
  owner: string | null;
  id: string | null;
  code: string | null;
  typeCodes: string[] | null;
  /** ID tag dispositivo (filtro multiplo). */
  deviceTagIds: number[] | null;
  /** ID guasti (filtro multiplo, tag con type diverso da device). */
  faultTagIds: number[] | null;
  currentPage: number;
  orderBy: string;
  ticketOpened: number;
  ticketClosed: number;
}

@Injectable({
  providedIn: 'root'
})
export class TicketFilterService {
  private filtersState = new BehaviorSubject<TicketFilters>({
    substatusIds: null,
    system: null,
    technician: null,
    owner: null,
    id: null,
    code: null,
    typeCodes: null,
    deviceTagIds: null,
    faultTagIds: null,
    currentPage: 1,
    orderBy: 'desc',
    ticketOpened: 1,
    ticketClosed: 1
  });

  filters$ = this.filtersState.asObservable();

  setFilters(filters: TicketFilters) {
    this.filtersState.next(filters);
  }

  /** Resetta tutti i filtri e imposta solo il filtro sullo status (per navigazione da dashboard). */
  setStatusFilter(status: TicketStatusWithSubS): void {
    const substatusIds =
      status?.idsubstatus != null ? [status.idsubstatus] : [];

    this.filtersState.next({
      substatusIds,
      system: null,
      technician: null,
      owner: null,
      id: null,
      code: null,
      typeCodes: null,
      deviceTagIds: null,
      faultTagIds: null,
      currentPage: 1,
      orderBy: 'desc',
      ticketOpened: 1,
      ticketClosed: 1
    });
  }

  getFilters() {
    return this.filtersState.value;
  }

  /** Reset utente: [] sugli stati evita di ripristinare i default dipartimento al rientro. */
  clearFilters() {
    this.filtersState.next({
      substatusIds: [],
      system: null,
      technician: null,
      owner: null,
      id: null,
      code: null,
      typeCodes: null,
      deviceTagIds: null,
      faultTagIds: null,
      currentPage: 1,
      orderBy: 'desc',
      ticketOpened: 1,
      ticketClosed: 1
    });
  }
}
